module.exports = "https://static.wmbcdn.com/uniweb/images/12c4c381b93f3555e38c76ce1a2b86ad.svg";